class MetaService {
  static updateMetaTags(participantsData, reactParticipantsData, isReactMode = false) {
    const currentData = isReactMode ? reactParticipantsData : participantsData;
    const { participants } = currentData;
    
    // Get top 3 participants
    const topThree = participants.slice(0, 3);
    
    // Create title and description
    const mode = isReactMode ? 'React Champions' : 'Problem Solvers';
    const title = `🏆 TechHub Leaderboard - Top ${mode}`;
    
    const topThreeNames = topThree.map((p, i) => {
      const medals = ['🥇', '🥈', '🥉'];
      return `${medals[i]} ${p.name}`;
    }).join(' | ');
    
    const description = `Current leaderboard champions: ${topThreeNames}. See who's leading the ${mode.toLowerCase()} competition at TechHub!`;
    
    // Update document title
    document.title = title;
    
    // Update or create meta tags
    this.setMetaTag('description', description);
    this.setMetaTag('og:title', title);
    this.setMetaTag('og:description', description);
    this.setMetaTag('og:type', 'website');
    this.setMetaTag('og:site_name', 'TechHub Leaderboard');
    
    // Twitter Cards
    this.setMetaTag('twitter:card', 'summary_large_image');
    this.setMetaTag('twitter:title', title);
    this.setMetaTag('twitter:description', description);
    
    // Additional sharing meta
    this.setMetaTag('keywords', `TechHub, leaderboard, ${isReactMode ? 'React, programming' : 'problem solving, coding'}, competition, champions, ${topThree.map(p => p.name).join(', ')}`);
    
    // Theme colors
    this.setMetaTag('theme-color', isReactMode ? '#61DAFB' : '#FFD700');
    this.setMetaTag('msapplication-TileColor', isReactMode ? '#61DAFB' : '#FFD700');
    
    console.log(`Meta tags updated for ${mode} mode:`, {
      title,
      description,
      topThree: topThree.map(p => p.name)
    });
  }
  
  static setMetaTag(name, content) {
    // Handle different meta tag types
    let selector;
    let attribute;
    
    if (name.startsWith('og:') || name.startsWith('twitter:')) {
      selector = `meta[property="${name}"]`;
      attribute = 'property';
    } else {
      selector = `meta[name="${name}"]`;
      attribute = 'name';
    }
    
    let metaTag = document.querySelector(selector);
    
    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.setAttribute(attribute, name);
      document.head.appendChild(metaTag);
    }
    
    metaTag.setAttribute('content', content);
  }
  
  static generateStructuredData(participantsData, reactParticipantsData, isReactMode = false) {
    const currentData = isReactMode ? reactParticipantsData : participantsData;
    const { participants } = currentData;
    const topThree = participants.slice(0, 3);
    
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": `TechHub ${isReactMode ? 'React Champions' : 'Problem Solvers'} Leaderboard`,
      "description": `Current leaderboard showing top performers in ${isReactMode ? 'React development' : 'problem solving'} at TechHub`,
      "itemListElement": topThree.map((participant, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "Person",
          "name": participant.name,
          "award": index === 0 ? "First Place" : index === 1 ? "Second Place" : "Third Place"
        }
      }))
    };
    
    // Remove existing structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }
    
    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData, null, 2);
    document.head.appendChild(script);
  }
  
  static updateCanonicalUrl() {
    const currentUrl = window.location.href;
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    
    canonicalLink.href = currentUrl;
  }
  
  static addShareableUrl() {
    // Add current URL to meta for easy sharing
    this.setMetaTag('og:url', window.location.href);
    this.setMetaTag('twitter:url', window.location.href);
  }
}

export default MetaService;